import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "biddesk_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export function applyAuthInterceptors(instance) {
  instance.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
  });
  instance.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
        setToken(null);
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
  return instance;
}

export const api = applyAuthInterceptors(axios.create({ baseURL: API }));
